export default __webpack_public_path__ + "static/media/icon-apple.4f3729a6.svg";